/**
 * Envío NR-1 · Qué le falta a un nodo para poder generar.
 *
 * Cada nodo arma su lista con `missingOf([...])`: cada entrada es `null`
 * (cumplido) o el texto de lo que falta. `<NodeRequirements>` la muestra
 * debajo del botón y `requirementsTitle` la deja como tooltip del botón
 * deshabilitado, así nadie queda frente a un botón bloqueado sin saber por qué.
 */

const KIND = {
  image: { thing: 'una imagen', node: 'imagen' },
  video: { thing: 'un video', node: 'video' },
  audio: { thing: 'un audio', node: 'audio' },
  style: { thing: 'la imagen de estilo', node: 'imagen' },
};

/** Falta de texto: prompt, guion, enlace… */
export function textNeed(value, label = 'escribir el prompt') {
  return String(value || '').trim().length > 0 ? null : label;
}

/**
 * Falta de un archivo de entrada.
 * - `ok`: el nodo ya tiene ese archivo (conectado con resultado, cargado o de la Galería).
 * - `connected`: hay un nodo conectado pero todavía no tiene resultado.
 */
export function inputNeed(kind, ok, { connected = false } = {}) {
  if (ok) return null;
  const k = KIND[kind] || KIND.image;
  if (connected) return `que el nodo de ${k.node} conectado tenga resultado: generalo primero`;
  return `${k.thing}: conectala desde otro nodo o cargala en este`
    .replace('conectala', kind === 'video' || kind === 'audio' ? 'conectalo' : 'conectala')
    .replace('cargala', kind === 'video' || kind === 'audio' ? 'cargalo' : 'cargala');
}

/** Condición libre: `cond` verdadera = cumplida. */
export function need(cond, label) {
  return cond ? null : label;
}

/** Lista final, sin cumplidos ni repetidos. */
export function missingOf(items) {
  return [...new Set((items || []).filter(Boolean))];
}

/** Texto corto para el tooltip del botón. */
export function requirementsTitle(missing) {
  if (!missing || !missing.length) return undefined;
  return `Para generar falta: ${missing.join('; ')}.`;
}
